import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestService } from 'src/app/services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-contact-vermittlung',
  templateUrl: './contact-vermittlung.component.html',
  styleUrls: ['./contact-vermittlung.component.css']
})
export class ContactVermittlungComponent implements OnInit {
  @Input() formName!: string
  mailSuccess: boolean = false;
  vermittlungForm: FormGroup

  constructor(
    private fb: FormBuilder,
    private request: RequestService,
    private snackbar: MatSnackBar
  ) { }
  ngOnInit(): void {
    this.vermittlungForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.minLength(4)]]
    })
  }

  submitForm() {
    if (this.vermittlungForm.valid) {
      const formData = this.vermittlungForm.value;
      formData["formName"] = this.formName
      this.request.posData("contacts", formData).subscribe(
        response => {
          this.vermittlungForm.reset()
          this.snackbar.open("Successfully sent", "OK", {
            duration: 5000,
            panelClass: ["mail-success"]
          })
          console.log(response)
        }
      )
    }
  }
}
